import { AChartComponent } from "./../components/achart/achart.component";
import { Injectable, ApplicationRef } from "@angular/core";
import { Workspace, ProxyWorkspace } from "../model/workspace.data";
import { Subject, Subscription } from "rxjs";
import { WorkspaceEventData } from "./workspace-event-data";
import { WorkspaceEventType } from "./workspace-event-type.enum";
import { HttpClient } from "@angular/common/http";
import * as xml2js from "xml2js";
import { IIndicatorsConfig } from "../components/achart/indicators";
import { ChartDisplayModeService } from "./layoutDisplayModeService/layoutDisplayModeService.service";
import { ChartDisplayMode } from "../enums/ChartDisplayMode.list";
import { ISymbolInfo } from "../interfaces/service.response";
import { GlobalGridModeService } from "./globalGridMode/globalGridMode.service";
import { QuoteTabsActiveModeService } from "./quoteTabsActiveMode/quoteTabsActiveMode.service";
import { SymbolTypeService } from "./quoteFilterTabsActiveMode/quoteFilterTabsActiveMode.service";
import { DataService } from "./data/data.service";
import { ChartButtonsVisibleService } from "./ChartButtonsVisible.service";
import { ShowChartTooltipService } from "./ShoChartTooltip.service";
import { ChartLayoutModeService } from "./chartLayoutMode/chartLayoutMode.service";
import { SettingsClient, TournamentClient, AccountsClient, AccountClient, HomeClient } from '../api/DixApiClient';
import { AppStoreClientEx } from "../api/AppStoreClientEx";
import { RoutingService } from "./routing.service";
import { CookiesService } from "../tools/cookies.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LandingPageClickStateService } from "./landingPageClickStateService/landingPageClickState.service";
import {GainService} from "./GAIN/gain.service";
import {Providers, ProviderInfo} from "../enums/providers";

@Injectable({
    providedIn: "root"
})
export class WorkspaceServiceService {
    public data: Workspace;

    Subscriber: Subject<WorkspaceEventData> = new Subject<WorkspaceEventData>();

    public GainService:GainService;

    constructor(
        private http: HttpClient,
        private app: ApplicationRef,
        private chartDisplayModeService: ChartDisplayModeService,
        private globalGridModeService: GlobalGridModeService,
        private quoteTabsActiveModeService: QuoteTabsActiveModeService,
        private symbolTypeService: SymbolTypeService,
        public dataService: DataService,
        private chartButtonsVisibleService: ChartButtonsVisibleService,
        private showChartTooltipService: ShowChartTooltipService,
        private activeLayoutTypeService: ChartLayoutModeService,
        private landingClickState: LandingPageClickStateService,
        private settingsClient: SettingsClient,
        private tournamentClient: TournamentClient,
        private accountsClient: AccountsClient,
        public routingService: RoutingService,
        public cookieService: CookiesService,
        public appStoreClient: AppStoreClientEx,
        public accountClient: AccountClient,
        public homeClient:HomeClient
    ) {
        this.dataService.mainService = this;
        (window as any).workspaceService = this;
        this.data = ProxyWorkspace(
            //new Workspace(
            app,
            chartDisplayModeService,
            globalGridModeService,
            quoteTabsActiveModeService,
            symbolTypeService,
            dataService,
            chartButtonsVisibleService,
            showChartTooltipService,
            activeLayoutTypeService,
            landingClickState,
            settingsClient,
            tournamentClient,
            accountsClient,
            homeClient,
            http,
            routingService,
            cookieService,
            appStoreClient,
            accountClient
        );
        this.subscribe();
        this.initIndicators();
        this.GainService = new GainService(this.http,this.settingsClient, this);
        ProviderInfo.RegisterProvider(Providers.GAIN, this.GainService)
    }

    private initIndicators() {
        this.http.get("/config/indicators.xml", { responseType: "text" }).subscribe(xml => {
            //  this.indicatorsXml=xml;
            xml2js.parseString(
                xml,
                {
                    trim: true,
                    mergeAttrs: true,
                    explicitArray: false
                },
                (err, res: IIndicatorsConfig) => {
                    this.data.indicators = res;
                    this.data.indicators.indicators.indicator.forEach(ind => {
                        ind.defaults.item.forEach(item => {
                            if (item.type == "array") {
                                item.array = JSON.parse(item.value);
                                item.value = (item.array || [""])[0];
                            }
                        });
                    });
                }
            );
        });
    }

    private subscribe() {
        // this.chartDisplayModeService.subscriber.subscribe(mode => {
        //     this.data.chartDisplayMode = mode;
        // });

        this.Subscriber.subscribe(ev => {
            this.log(ev);
            switch (ev.Type) {
                case WorkspaceEventType.DragAndDropSymbol:
                    break;
                case WorkspaceEventType.BoxOpenMode:
                    break;
                // case WorkspaceEventType.ChartInstanceSelect:
                // {
                //   let chart: AChartComponent=<AChartComponent>ev.Data;
                //   if(chart!==this.data.selectedChart && this.data.selectedChart) {
                //       this.data.selectedChart.isSelected=false;
                //   }
                //   this.data.selectedChart=chart;
                // }
                // break;
                // case WorkspaceEventType.ChartInstanceUnselect:
                //   this.data.unselectChart(<AChartComponent>ev.Data);
                // break;
                case WorkspaceEventType.ChartLayoutMode:
                    break;
                case WorkspaceEventType.ChartOpenMode:
                    break;
                case WorkspaceEventType.GlobalGridMode:
                    break;
                case WorkspaceEventType.LayoutDisplayMode:
                    break;
                case WorkspaceEventType.Login:
                    break;
                case WorkspaceEventType.LogOff:
                    break;
                case WorkspaceEventType.MonitorPeriod:
                    break;
                case WorkspaceEventType.QuoteFilterTabActiveMode:
                    break;
                case WorkspaceEventType.QuoteTabActiveMode:
                    break;
                case WorkspaceEventType.RangeButton:
                    break;
                case WorkspaceEventType.Resize:
                    break;
                case WorkspaceEventType.SpaceAfterData:
                    break;
            }
        });
    }

    public Unsubscribe(subscribtion: Subscription) {
        subscribtion.unsubscribe();
    }

    public SendEvent(type: WorkspaceEventType, data?: any) {
        // setImmediate(()=>{
        //   this.Subscriber.next({
        //     Type: type,
        //     Data: data
        //   });
        // });
    }

    public log(msg: any) {
        // setImmediate(()=>{
        //   console.log(msg);
        // });
    }
}
